import { moveMailMessage } from "@/lib/api/mailActions";
import { markMailMessageUnread } from "@/lib/api/imap";
import type { MailSnoozeWoke } from "@/lib/snooze/constants";

function groupWokeByFolder(woke: MailSnoozeWoke[]): Map<string, number[]> {
  const byFolder = new Map<string, number[]>();

  for (const item of woke) {
    if (item.uid <= 0 || !item.folder) continue;
    const list = byFolder.get(item.folder) ?? [];
    list.push(item.uid);
    byFolder.set(item.folder, list);
  }

  return byFolder;
}

async function markFoldersUnread(
  accountId: number,
  byFolder: Map<string, number[]>
): Promise<Map<string, number[]>> {
  const failed = new Map<string, number[]>();

  await Promise.all(
    [...byFolder.entries()].map(async ([folder, uids]) => {
      const unique = [...new Set(uids.filter((uid) => uid > 0))];
      if (unique.length === 0) return;

      const res = await markMailMessageUnread({ accountId, folder, uids: unique });
      if (!res.ok) {
        failed.set(folder, unique);
        console.warn("[Mail snooze] non lu IMAP échoué:", folder, unique, res.message);
      }
    })
  );

  return failed;
}

/** Restaure depuis le dossier attente IMAP puis marque non lu dans le dossier d’origine. */
export async function markWokeMessagesUnread(
  accountId: number,
  woke: MailSnoozeWoke[]
): Promise<boolean> {
  if (woke.length === 0) return true;

  for (const item of woke) {
    if (item.uid <= 0 || !item.folder) continue;
    const hold = item.holdFolder?.trim();
    const holdUid = item.holdUid != null && item.holdUid > 0 ? item.holdUid : item.uid;
    if (hold && hold !== item.folder) {
      const moveRes = await moveMailMessage({
        accountId,
        folder: hold,
        uid: holdUid,
        targetFolder: item.folder,
      });
      if (!moveRes.ok) {
        console.warn("[Mail snooze] restore IMAP échoué:", hold, item.uid, moveRes.message);
      }
    }
  }

  const byFolder = groupWokeByFolder(woke);
  if (byFolder.size === 0) return true;

  let failed = await markFoldersUnread(accountId, byFolder);
  if (failed.size === 0) return true;

  await new Promise((resolve) => window.setTimeout(resolve, 600));
  failed = await markFoldersUnread(accountId, failed);
  return failed.size === 0;
}
